export const NO_CONSOLE_PERMISSIONS_ERROR_MESSAGE =
  "No console permissions for this account.";
